import { useState } from 'react';
import { PageContainer } from '../../../components/PageContainer';
import { DataUsageCards } from '../../../components/DataUsageCards';
import { OverviewData } from '../../../components/OverviewData';
import { useGetCombinedDataUsageQuery, useGetCamerasQuery } from '../../cameras/api/camerasApi';
import { FullScreenSpinner } from '../../../components/Spinner/Spinner';
import styled from 'styled-components';

export const CombinedDataUsage = () => {
  const [month, setMonth] = useState<string | undefined>();

  const { data, isLoading } = useGetCombinedDataUsageQuery(
    month ? { month } : undefined
  );
  const { data: camerasData } = useGetCamerasQuery();
  const planTotalGB = camerasData?.overallSummary.totalProductGB;

  return (
    <PageContainer title="Combined Data Usage" onGoBack="/dashboard">
      {isLoading || !data ? (
        <FullScreenSpinner />
      ) : (
        <Content>
          <DataUsageCards data={data} />
          <OverviewData data={data} onMonthChange={setMonth} planTotalGB={planTotalGB} />
          <TipsCard>
            <TipsTitle>Tips to reduce data usage</TipsTitle>
            <TipsList>
              <li>Our plans are not unlimited — keep an eye on your monthly usage.</li>
              <li>Reduce the amount of time you stay logged in to live view.</li>
              <li>Ensure cloud recordings are turned off — this feature requires an unlimited 4G plan, which we don't offer.</li>
              <li>Avoid viewing from a PC — it's easy to leave a stream open and forget, which will quickly run down your allowance.</li>
            </TipsList>
          </TipsCard>
        </Content>
      )}
    </PageContainer>
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const TipsCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray900};
  border-radius: 0.5rem;
  padding: 1rem 1.25rem;
`;

const TipsTitle = styled.h3`
  margin: 0 0 0.5rem;
  font-size: ${({ theme }) => theme.fontSize.medium};
  font-weight: 600;
`;

const TipsList = styled.ul`
  margin: 0;
  padding-left: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-size: ${({ theme }) => theme.fontSize.small};
  color: ${({ theme }) => theme.colors.gray500};
  line-height: 1.5;
`;
